import * as React from 'react';
import { useStore } from '../store.js';

const useSaga = (saga, options, deps = [])=>{
    const store = useStore();
    const [task, setTask] = React.useState(null);
    React.useDebugValue(task, (t)=>t && {
            isRunning: t.isRunning(),
            error: t.error(),
            result: t.result()
        }
    );
    React.useEffect(()=>{
        const runningSaga = store.runSaga(saga);
        setTask(runningSaga);
        if (options === null || options === void 0 ? void 0 : options.onStart) {
            options === null || options === void 0 ? void 0 : options.onStart(runningSaga);
        }
        return ()=>{
            runningSaga.cancel();
        };
    // options.onStart is left out on purpose
    // putting in would cause infinite loops
    }, [
        store,
        saga,
        ...deps
    ]);
    return task;
};

export { useSaga };
//# sourceMappingURL=use-saga.js.map
